// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
import App from "./App"
import locale_en from 'element-ui/lib/locale/lang/en'
import locale_zh from 'element-ui/lib/locale/lang/zh-CN'
import ElementLocale from 'element-ui/lib/locale'
import router from './router'
import { getLangInUrl, getUrlParamNative } from "../common/utils/routerUtil"
import VueI18n from "vue-i18n"


import defaultImage from './assets/images/e8d52bef-b4ab-49df-9696-9357e9151aeb.png'
import store from "./store/index"
import "./components/gComponent"
import ElementUI from "element-ui"
import { isShengzheng } from "../wenxing/constants"
import { initTIM, loginIM, eventlist, getUserId } from '@common/utils/imUtils.js'

import { setCookie, getLoginUser } from '@common/utils'

Vue.config.productionTip = false
/* eslint-disable no-new */

var lang = getLangInUrl() || getUrlParamNative("lang") || sessionStorage.getItem("lang") || "zh" //默认中文
const i18n = new VueI18n({
  locale: lang, // 语言标识 //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    zh: require("@common/VueI18n/language-zh"),
    en: require("@common/VueI18n/language-en")
  }
})
ElementLocale.i18n((key, value) => i18n.t(key, value))

Vue.use(ElementUI, {
  locale: lang === 'en' ? locale_en : locale_zh
})

Vue.prototype.g = {
  projectId: "",
  defaultImage,
  isSz: isShengzheng,
  lang: lang,
  isEn: lang == 'en',
  uploadUrlBefore: process.env.NODE_ENV == 'production' ? '' : '/api',
}
sessionStorage.setItem("lang", lang)

Vue.use(ElementUI, {
  size: "small",
  zIndex: 3000,
  i18n: (key, value) => i18n.t(key, value)
})

// var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
// (function () {
//   var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
//   s1.async = true;
//   s1.src = 'https://embed.tawk.to/60a603fd185beb22b30eff9b/1f647v5pt';
//   s1.charset = 'UTF-8';
//   s1.setAttribute('crossorigin', '*');
//   s0.parentNode.insertBefore(s1, s0);
// })();
var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date()
// (function(){
// var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
// s1.async=true;
// s1.src='https://embed.tawk.to/61c575c880b2296cfdd39ba8/1fnll89jk';
// s1.charset='UTF-8';
// s1.setAttribute('crossorigin','*');
// s0.parentNode.insertBefore(s1,s0);
// })();
// var _hmt = _hmt || [];
// (function () {
//   var hm = document.createElement("script");
//   hm.src = "https://hm.baidu.com/hm.js?b5ca1270d5f086ec82d5f863ed7f3f2f";
//   var s = document.getElementsByTagName("script")[0];
//   s.parentNode.insertBefore(hm, s);
// })();


function initVm () {
  window._vm = new Vue({
    el: "#app",
    router,
    i18n,
    store,
    components: { App },
    template: "<App/>"
  })
}

function init () {
  const isLogin = !!getLoginUser()
  console.log("isLogin-->", isLogin)
  if (!isLogin) {
    initVm()
    return
  }
  initTIM().then(res => {
    console.log(res)
    eventlist()
    console.log("登录的用户的id", getUserId())
    loginIM(getUserId()).then(res => {
      console.log(res)
      initVm()
    }).catch(e => {
      console.error(e)
      initVm()/*不管im初始化失败还是成功 都得初始化vue*/
    })
  })
}

init()








// WEBPACK FOOTER //
// ./src/wenxing/main.js